import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './Investments.css';

const InvestmentDetails = () => {
  const { investmentId } = useParams();
  const [investment, setInvestment] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // NEW: State to manage the currently displayed main image URL
  const [activeMainImage, setActiveMainImage] = useState('');

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchInvestment = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`https://apiqms.shigjeta.com/api/investments/${investmentId}`);
        const investmentData = response.data;
        setInvestment(investmentData);

        // NEW: Set the initial active image when the data is fetched
        const initialMainImageUrl = investmentData.mainImage && !investmentData.mainImage.startsWith('http')
          ? `https://apiqms.shigjeta.com${investmentData.mainImage}`
          : investmentData.mainImage;
        setActiveMainImage(initialMainImageUrl);

      } catch (err) {
        console.error("Error fetching investment details:", err);
        setError("Failed to load investment details.");
      } finally {
        setIsLoading(false);
      }
    };

    if (investmentId) {
      fetchInvestment();
    }
  }, [investmentId]);

  // NEW: Click handler function to update the main image
  const handleThumbnailClick = (newImageUrl) => {
    setActiveMainImage(newImageUrl);
  };

  if (isLoading) return <p className="loading-message">Loading Investment...</p>;
  if (error) return <p className="error-message">{error}</p>;
  if (!investment) return <p>Investment not found.</p>;

  const tagsArray = investment.tags
    ? (Array.isArray(investment.tags) ? investment.tags : investment.tags.split(',').map(t => t.trim()))
    : [];

  // This logic is now only needed for preparing the array, not for displaying the main image directly
  const additionalImagesArray = investment.additionalImages
    ? (Array.isArray(investment.additionalImages)
        ? investment.additionalImages.map(img => ({
          ...img,
          src: img.src && !img.src.startsWith('http') ? `https://apiqms.shigjeta.com${img.src}` : img.src
        }))
        : [])
    : [];

  return (
    <div className="investment-detail">
      
      <div className="investment-main-content">
        
        {/* === LEFT COLUMN === */}
        <div className="investment-left-column">
          {/* NEW: The src is now bound to our 'activeMainImage' state */}
          {activeMainImage && (
            <img src={activeMainImage} alt={investment.title} className="investment-main-image" />
          )}

          {additionalImagesArray.length > 0 && (
            <div className="investment-additional-images">
              {additionalImagesArray.map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt || `Additional image ${index + 1}`}
                  className="additional-image-item"
                  // NEW: onClick event that calls our handler with the image's src
                  onClick={() => handleThumbnailClick(image.src)}
                />
              ))}
            </div>
          )}
        </div>

        {/* === RIGHT COLUMN === */}
        <div className="investment-right-column">
          <div className="investment-text-content">
            <h1 className="investment-title">{investment.title}</h1>
            <p className="investment-category">CATEGORY: {investment.category}</p>
            <div className='investment-description' dangerouslySetInnerHTML={{ __html: investment.description }} />
            
            {investment.specification && (
              <>
                <h3 className="specification-label">Specification:</h3>
                <div className='investment-specification' dangerouslySetInnerHTML={{ __html: investment.specification }} />
              </>
            )}

            {tagsArray.length > 0 && (
              <div className="investment-tags">
                <h3 className="tags-title">Tags:</h3>
                <ul className="tags-list">
                  {tagsArray.map((tag, index) => (
                    <li key={index} className="tag-item">{tag}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetails;